import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type BlogData = {
  name: string
  id: string
  viewMode: string
  marginBottom: string
}
export const blog: DynamicContentType<BlogData> = {
  name: 'blog',
  viewName: 'Nyhetsflöde',
  icon: LucideIconName.Newspaper,
  uuid: '',
  featureKey: 'blog',
  data: {
    name: '',
    id: '',
    viewMode: 'list',
    marginBottom: '2rem',
  },
}
